import React, {useContext} from 'react';
import { useHistory } from 'react-router-dom';
import TopNav from 'components/TopNav';
import BottomNav from 'components/BottomNav';
import cookie from 'js-cookie';
import style from './style.module.scss';
import { AUTH_TOKEN, AUTH_TOKEN_WEB, DISPLAY_BUTTON } from '../../config/constants';
import RenderSvgIcon from '../../components/RenderSvgIcon';
import { AuthContext } from '../../context/AuthContext';
import { AppContext } from '../../context/AppContext';


function Account() {
  const history = useHistory();
  const pushPage = (url) => {
    history.push({ pathname: url });
  };
  const authContext = useContext(AuthContext);
  const appContext = useContext(AppContext);

  const envUi = authContext.envUi

  const logout = () => {
    if (window.confirm('ログアウトしますか？')) {
      cookie.remove(AUTH_TOKEN);
      cookie.remove(AUTH_TOKEN_WEB);
      appContext.funcLogout();
      cookie.remove('hidden_bottom_nav');
      window.location.href = '/';
    }
  };

  const wrapStyleArrow = {
    paddingRight: 3,
    width: 24,
    height: 24,
    color: 'var(--text-secondary)',
    fill: 'currentColor'
  };

  return (
    <div style={{ overflow: 'auto', height: '100vh' }}>
      <div style={{ maxWidth: 560, margin: 'auto' }}>
        <TopNav name={'設定'} hasBackIcon={true} hasHamburger={true} />
        <div className={`${style.back_white_wrap} align-top`}>
          <div onClick={() => pushPage(`${process.env.RAZZLE_PUBLIC_URL}/info-account`)}>
            <div className={style.div__img}>
              <img src={require('assets/image-icon/check_setting.png')} className={style.icon} alt="Info Account" />
            </div>
            <div className={style.div__icon}>
              <span className="font-2">設定の確認</span>
              <RenderSvgIcon
                name={'SVG_forward_right_icon'}
                fill="var(--text-secondary)"
                style={wrapStyleArrow}
                className={'d-svg'}
              />
            </div>
          </div>
          {/* <div onClick={() => pushPage('/favorite')}>
            <div className={style.div__img}>
              <img src={require('assets/image-icon/favorite.png')} className={style.icon} alt="Info Account" />
            </div>
            <div className={style.div__icon}>
              <span className="font-2">お気に入り</span>
              <RenderSvgIcon
                name={'SVG_forward_right_icon'}
                fill="var(--text-secondary)"
                style={wrapStyleArrow}
                className={'d-svg'}
              />
            </div>
          </div>
          <div onClick={() => pushPage('/footprint')}>
            <div className={style.div__img}>
              <img src={require('assets/image-icon/footprint.png')} className={style.icon} alt="Info Account" />
            </div>
            <div className={style.div__icon}>
              <span className="font-2">足跡</span>
              <RenderSvgIcon
                name={'SVG_forward_right_icon'}
                fill="var(--text-secondary)"
                style={wrapStyleArrow}
                className={'d-svg'}
              />
            </div>
          </div> */}
            {
              envUi.displayAccountMenuBlockList === DISPLAY_BUTTON.SHOW && (
              <div onClick={() => pushPage(`${process.env.RAZZLE_PUBLIC_URL}/blocklist`)}>
                <div className={style.div__img}>
                  <img src={require('assets/image-icon/block_list.png')} className={style.icon} alt="Contact" />
                </div>
                <div className={style.div__icon}>
                  <span className="font-2">ブロックしたリスト</span>
                  <RenderSvgIcon
                    name={'SVG_forward_right_icon'}
                    fill="var(--text-secondary)"
                    style={wrapStyleArrow}
                    className={'d-svg'}
                  />
                </div>
              </div>
              )
            }
            {
              envUi.displayAccountMenuContactAgeverification === DISPLAY_BUTTON.SHOW && (
                <div onClick={() => pushPage(`${process.env.RAZZLE_PUBLIC_URL}/contactageverification`)}>
                  <div className={style.div__img}>
                    <img src={require('assets/image-icon/ageverification.png')} className={style.icon} alt="Contact" />
                  </div>
                  <div className={style.div__icon}>
                    <span className="font-2">年齢認証</span>
                    <RenderSvgIcon
                      name={'SVG_forward_right_icon'}
                      fill="var(--text-secondary)"
                      style={wrapStyleArrow}
                      className={'d-svg'}
                    />
                  </div>
                </div>
              )
            }
            <div onClick={logout}>
              <div className={style.div__img}>
                <img src={require('assets/image-icon/logout.png')} className={style.icon} alt="Contact" />
              </div>
              <div className={style.div__icon}>
                <span className="font-2">ログアウト</span>
                <RenderSvgIcon
                  name={'SVG_forward_right_icon'}
                  fill="var(--text-secondary)"
                  style={wrapStyleArrow}
                  className={'d-svg'}
                />
              </div>
            </div>
          </div>
        <BottomNav />
      </div>
    </div>
  );
}

export default Account;
